import {_serializeSingle, _serializeList} from '../core';
import type {ServerData} from '../core';

export function serializeResource(data: ServerData) {
    return _serializeSingle("resource", data);
}

export function serializeResourceList(data: ServerData) {
    return _serializeList("resource", data);
}
